// extracted by mini-css-extract-plugin
export var avatarContainer = "_ap-0";
export var avatarTypingWave = "_ap-i";
export var gray = "_ap-f";
export var green = "_ap-c";
export var icon = "_ap-9";
export var image = "_ap-1";
export var lg = "_ap-6";
export var md = "_ap-5";
export var presenceDot = "_ap-b";
export var red = "_ap-d";
export var sm = "_ap-4";
export var status = "_ap-a";
export var typingDot = "_ap-h";
export var typingPill = "_ap-g";
export var xl = "_ap-7";
export var xs = "_ap-3";
export var xxl = "_ap-8";
export var xxs = "_ap-2";
export var yellow = "_ap-e";